module.exports = __webpack_public_path__ + "static/media/wellbeing-foundations@3x.c65c4b6a.png";